module.exports = __webpack_public_path__ + "img/font.ac9f204b.svg";